import { useMutation } from '@connectrpc/connect-query'
import { exportCustomerContracts } from '@ebalance/proto/bffuser/v1/customer_contract_csv_service-CustomerContractCsvService_connectquery'

import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 契約推移タブの「CSVエクスポート」用の全件取得フック。顧客契約 CSV のダウンロード
 * (データ入稿画面の `useExportCustomerContracts`) と同じ RPC を、開いた時の 1 回限りの命令的取得として使う。
 */
export function useExportContractCsv(): InvalidatingMutationResultFor<
  typeof exportCustomerContracts
> {
  return useMutation(exportCustomerContracts)
}
